const formatPercentage = (percentage) => {
    if (percentage > 0 && percentage < 1)
        return '<1%';
    return `${percentage.toFixed(0)}%`;
};
export default formatPercentage;
